import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './ConveraStatementsTableHeadRow.scss';

export const CONVERA_STATEMENTS_TABLE_HEADER = [
  {
    label: 'filename'
  },
  {
    label: 'type'
  },
  {
    label: 'createdAt',
    sortable: true
  }
];

const ConveraStatementsTableHeadRow = ({ handleOnSortTable, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {CONVERA_STATEMENTS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'convera-statements-table-head'}>
          <div className={'convera-statements-table-head-block'}>
            <span>{i18n.getMessage(`converaStatements.table.header.${head.label}`)}</span>
            {head.sortable && (
              <ArrowSelect
                onClick={handleOnSortTable}
                className={`convera-statements-sorting-arrow-icon ${direction}`}
              />
            )}
          </div>
        </th>
      ))}
    </tr>
  );
};

ConveraStatementsTableHeadRow.propTypes = {
  handleOnSortTable: PropTypes.func,
  direction: PropTypes.string
};

export default ConveraStatementsTableHeadRow;
